<template>



  <div class="login-page">
    <div class="login-form">

      <h1 class="is-size-1"><img class="logo-filekom" src="../assets/images/filedoc-01.png" alt="">
        <!-- <span class="has-text-grey">FILE</span><span class="has-text-filekom">KOM</span> -->

        <span class="has-text-info">Clientes</span>
      </h1>


      <form>
        <section>
          <b-field label="Usuario">
            <b-input v-model="credentials.username" placeholder="Ingrese su nombre de usuario o email"
              type="text"></b-input>
          </b-field>

          <b-field label="Clave">
            <b-input v-model="credentials.password" placeholder="Ingrese su clave secreta" type="password"></b-input>
          </b-field>

          <div class="control btnlogin">
            <button @click.prevent="doLogin" class="button is-large is-info is-rounded is-fullwidth">Iniciar
              sesión</button>
          </div>



        </section>
      </form>
    </div>
  </div>

</template>


<script>

import { mapActions } from 'vuex'
import Util from '../util'



export default {
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      error: ''
    }
  },

  methods: {
    ...mapActions({ 'login': 'auth/login' }),
    doLogin() {
      this.login({ context: this, credentials: this.credentials }).then(() => {
        this.$router.push({ name: 'home' })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}

</script>


<style  lang="scss">
body,
html {
  height: 100%;
}

.login-page {
  display: flex;
  flex-direction: row;
  height: 100%;
  background-color: #eee;
}

.login-form {
  width: 480px;
  margin: auto;
}

form {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  padding: 20px;

  input,
  button {
    width: 100%;
    margin: 5px 0;
  }
}


.logo-filekom {
  width: 250px;
}

.btnlogin {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;

}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue